function Footer () {

    const expoGoLinkUrl = 'https://expo.dev/client';
    const expoGoLink = (
        <button className="p-4 hover:bg-blue-800 text-blue-400 font-bold py-2 px-2 rounded"
            type="button"
            onClick={() => window.open(expoGoLinkUrl)}
        >
            Expo Go
        </button>

    );

    const expoLinkUrl = 'https://expo.dev/accounts/industrialcuriosity/projects/propolis/updates/c760bc30-c3a4-4774-8997-edd149c286f2';
    const expoLink = (
        <button className="p-4 hover:bg-blue-800 text-blue-400 font-bold py-2 px-2 rounded"
            type="button"
            onClick={() => window.open(expoLinkUrl)}
        >the latest build</button>
    );

    const adminEmail = 'propolis@industrialcuriosity.com';
    const emailButton = (
        <button className="p-4 hover:bg-blue-800 text-blue-400 font-bold py-2 px-4 rounded"
            type="button"
            onClick={() => window.open(`mailto:${adminEmail}?subject=Assistance%20required`)}
        >
            {adminEmail}
        </button>
    );

    return (
        <div>
            <div>
                <p>
                To install the Expo app, install the {expoGoLink} app on your device and
                then head to {expoLink}. Select the "preview" button for your device and
                then scan the QR code to proceed.</p>
                <p>If you have a previous version of the Propolis app installed, you may
                need to explicitly choose the development branch from the project window
                to open the correct version.
                </p>
            </div>
            <div>
                Need assistance? Please contact {emailButton}
            </div>
            <div>
                Attributions:<br />
                <a href="https://www.freepik.com/photos/food">Food photo created by Racool_studio - www.freepik.com</a>
            </div>
        </div>
    );
}

export default Footer;